import useLocale from "~/hook/useLocale";
import { setIsDialogOpen, setNavigatTo } from "~/lib/store/slice/loginSlice";
import { useAppDispatch } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, AUTH_ROUTE } from "~/utils/constant";
import { getCookie } from "~/utils/cookies";

const useAuthRoute = () => {
  const dispatch = useAppDispatch();
  const { navigate } = useLocale();

  const handleNavigate = (url: string) => {
    if (AUTH_ROUTE.includes(url)) {
      const token = getCookie(AUTH_COOKIE_TOKEN);
      if (!token) {
        dispatch(setNavigatTo(url));
        dispatch(setIsDialogOpen());
      } else {
        navigate(url);
      }
    } else {
      navigate(url);
    }
  };

  const isProtectedRoute = (url: string) => {
    return AUTH_ROUTE.includes(url) && !getCookie(AUTH_COOKIE_TOKEN);
  };

  const isAuthenticated = () => {
    return !!getCookie(AUTH_COOKIE_TOKEN);
  };

  return {
    handleNavigate,
    isProtectedRoute,
    isAuthenticated,
  };
};

export default useAuthRoute;
